

//
// Ensure that the ws object exists
//
if(!window.ws) window.ws = {};

require('./ws_info');
require('./log_dev');
require('./csrf_token');
require('./js_call_post');
require('./select');
require('./svg_parcel');
require('./svg_summary_widget');
require('./svg_summary_widget_big');
require('./getPendingStatusAttribute');
require('./coordinates_input');


